// Seelenhaenger Theme JS

document.addEventListener('DOMContentLoaded', () => {
  // Mobile nav toggle
  const mobileBtn = document.querySelector('.header-menu-mobile');
  const nav = document.querySelector('.header-nav');
  if (mobileBtn && nav) {
    mobileBtn.addEventListener('click', () => {
      const open = nav.classList.toggle('header-nav--open');
      mobileBtn.setAttribute('aria-expanded', String(open));
    });
  }

  // Variant selector
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-btns');
      group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
});
